export default __webpack_public_path__ + "static/media/졸작-1.3b35c77e.png";